import React from 'react';
import CategoryLandingPage from './CategoryLandingPage';
import { wineConfig } from '../configs/categoryLandings';

export default function WineLandingPage() {
  return <CategoryLandingPage config={wineConfig} />;
}
